import React, { useEffect } from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateGoldConversionStatusReduxParams } from '~types/feat/approval';

import { GoldConversionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateGoldConversionStatusModal.module.scss';

const ConfirmUpdateGoldConversionStatusModal = () => {
    const isOpen = useAppSelector(state => state.approval.modals.confirmUpdateGoldConversionModalIsOpen);
    const tempUpdateGoldConversionState = useAppSelector(state => state.approval.tempUpdateGoldConversionState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateGoldConversionStatus);
    const error = useAppSelector(state => state.approval.errors.updateGoldConversionStatus);

    const getStatus = () => {
        switch (tempUpdateGoldConversionState.status) {
            case (GoldConversionStatusEnum.Approved): return 'Approve';
            case (GoldConversionStatusEnum.Rejected): return 'Reject';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateGoldConversionStatusModalIsOpen(open));
    const updateBranchStatus = (data: TUpdateGoldConversionStatusReduxParams) => dispatch(combinedActions.approvalUpdateGoldConversionStatusAttempt(data));

    const handleSubmitClick = () => {
        updateBranchStatus(tempUpdateGoldConversionState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Approve' ? Styles['confirm-approve'] : ''),
        (getStatus() === 'Reject' ? Styles['confirm-reject'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateGoldConversionStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            testId='approval-goldConversion-modal-close-button'
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} Conversion?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    testId='approval-goldConversion-confirmModal-cancel-button'
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    testId='approval-goldConversion-confirmModal-approveReject-button'
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateGoldConversionStatusModal;
